import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LoadingController, Loading } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { FotoProvider } from '../../providers/foto/foto'

@IonicPage()
@Component({
  selector: 'page-imagem-ged',
  templateUrl: 'imagem-ged.html',
})
export class ImagemGedPage {

  public formulario: FormGroup;
  private emailUsuario: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, 
    private fotoProvider: FotoProvider, private formBuilder: FormBuilder, 
    private toastController: ToastController, private loadingController: LoadingController,
    private httpClient: HttpClient) {
      this.emailUsuario = this.navParams.get('email');
      this.formulario = this.construirFormulario();
  }

  public get foto(): string {
    return this.getControlFoto().value;
  }

  private construirFormulario(): FormGroup {
    return this.formBuilder.group({
      "foto": ['', Validators.required]
    });
  }

  private adicionarFoto(base64: string): void {
    this.getControlFoto().setValue(base64);
  }

  public tirarFoto(): void {
    const loading = this.criarLoading();
    loading.present();
    this.fotoProvider.tirarFoto().then(
      base64 => {
        loading.dismiss();
        this.adicionarFoto(base64);
      }, error => {
        loading.dismiss();
        console.log(JSON.stringify(error))
      }
    );
  }

  public selecionarFotoDaGaleria(): void {
    const loading = this.criarLoading();
    loading.present();
    this.fotoProvider.abrirImagemDaGaleria().then(
      base64 => {
        loading.dismiss();
        this.adicionarFoto(base64);
      }, error => {
        loading.dismiss();
        console.log(JSON.stringify(error))
      }
    );
  }

  public montarFotoParaVisualizacao(fotoBase64: string):string {
    const codificadorImagemJPEGBase64 = "data:image/jpeg;base64,";
    return codificadorImagemJPEGBase64 + fotoBase64;
  }

  public removerFoto(): void {
    this.getControlFoto().setValue('');
  }

  private getControlFoto(): AbstractControl {
    return this.formulario.get('foto');
  }

  private criarNomenclaturaArquivo(): string {
    return `brcomunique-${new Date().getTime()}`;
  }

  private async enviarImagemHTTPAngular(): Promise<void> {
    const loading = this.criarLoading();
    loading.present();
    const nomeArquivo = this.criarNomenclaturaArquivo();
    const URL = `http://mormot.lideranca.com.br:7098/root/funcao/0/EnviaGED?email=${this.emailUsuario}&nomeArquivo=${nomeArquivo}.jpg`;
    const blobImagem = await (await fetch(this.montarFotoParaVisualizacao(this.getControlFoto().value))).blob();
    const formData = new FormData();
    formData.append('arquivo', blobImagem);
    this.httpClient.post(URL, formData, {responseType: 'text'}).subscribe(
      resp => {
        loading.dismiss();
        this.apresentarMensagemDeSucesso();
        this.navCtrl.pop();
      }, error => {
        loading.dismiss();
        console.log(JSON.stringify(error));
        this.apresentarMensagemDeErro();
      }
    );
  }

  public async enviarImagem(): Promise<void> {
    this.enviarImagemHTTPAngular();
  }

  private criarLoading(): Loading {
    return this.loadingController.create({content: 'Aguarde...'});
  }

  private apresentarMensagemDeSucesso(): void {
    this.apresentarToast("Imagem enviada com sucesso!");
  }

  private apresentarMensagemDeErro(): void {
    this.apresentarToast("Ocorreu um erro inesperado, por favor tente novamente mais tarde");
  }

  private apresentarToast(mensagem: string): void {
    const toast = this.toastController.create({
      message: mensagem,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/imagem-ged/imagem-ged.ts